/* eslint-disable no-useless-escape */
import { Categories as PlatformCategories } from 'models/business/Platform';
import { Categories as ProductCategories } from 'models/business/Product';
import Asset, { Categories as AssetCategories } from 'models/business/Asset';
import Market from 'models/business/Market';
import { workingDaysLater } from 'tools/date';

// ......?
export const Statuses = Object.freeze({
  Incomplete: 'Undone',
  Pending: 'Pending',
  Online: 'Online',
  Stopped: 'Stopped',
});

export const PresentationFormats = Object.freeze({
  Carousel: 'carousel',
  Featured: 'featured',
});

export const ProductRanges = Object.freeze({
  Total: '全館商品',
  Selected: '僅投放部分商品',
});

const URLRegex = new RegExp(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www\.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/);

export default class Ad {
  constructor(data) {
    this.assets = [];
    this.market = new Market();

    this.id = '';
    this.marketId = '';
    this.marketContentFeedId = '';
    this.contentFeedId = '';
    this.contentFeedCategory = AssetCategories.ContentFeed;
    this.name = '';
    this.status = Statuses.Incomplete;
    this.dayBudget = 100;
    this.startDate = this.earliestStartingDate;
    this.platform = ''; // PlatformCategories.Google;
    this.advertisingGoal = '';
    this.averagePricePerCustomer = 30;
    this.productCategory = ProductCategories.WomensApparel;
    this.toBought = true;
    this.toAddedCart = true;
    this.toSameType = true;
    this.mainCopy = '';
    this.title = '';
    this.description = '';
    this.cta = '';
    this.hostingUrl = '';
    this.youtubeUrl = '';
    this.shortTitle = '';
    this.googleDescription = '';

    this.initialize(data);
  }

  initialize(data = {}) {
    this.id = data.id ?? this.id;
    this.marketId = data.mallId ?? data.marketId ?? this.marketId;
    this.marketContentFeedId = data.mallContentId
      ?? data.marketContentFeedId ?? this.marketContentFeedId;
    this.contentFeedId = data.inventoryId ?? data.contentFeedId ?? this.contentFeedId;
    this.contentFeedCategory = data.inventoryCategory
      ?? data.contentFeedCategory ?? this.contentFeedCategory;
    this.name = data.name ?? this.name;
    this.status = data.adStatus ?? data.status ?? this.status;
    this.dayBudget = data.dayBudget ?? this.dayBudget;
    this.startDate = new Date(data.startDate || this.startDate);
    this.platform = data.platform ?? this.platform;
    this.advertisingGoal = data.advertisingGoal ?? this.advertisingGoal;
    this.averagePricePerCustomer = data.avgPricePerCustomer
      ?? data.averagePricePerCustomer
      ?? this.averagePricePerCustomer;
    this.productCategory = data.productType ?? data.productCategory ?? this.productCategory;
    this.toBought = data.toBought ?? this.toBought;
    this.toAddedCart = data.toAddedCart ?? this.toAddedCart;
    this.toSameType = data.toSameType ?? this.toSameType;
    this.mainCopy = data.writting ?? data.mainCopy ?? this.mainCopy;
    this.title = data.adTitle ?? data.title ?? this.title;
    this.description = data.adTitleDescrpt ?? data.description ?? this.description;
    this.cta = data.moveAppealOption ?? data.cta ?? this.cta;
    this.hostingUrl = data.adImportUrl ?? data.hostingUrl ?? this.hostingUrl;
    this.youtubeUrl = data.youtubeUrl ?? this.youtubeUrl;
    this.shortTitle = data.shortAdTitle ?? data.shortTitle ?? this.shortTitle;
    this.googleDescription = data.googleTitleDescrpt
      ?? data.googleDescription
      ?? this.googleDescription;

    this.assets = data.assets ?? this.assets;
    this.market = data.market ?? this.market;

    Object.keys(this).forEach((k) => {
      if (this[k] === 'null') {
        this[k] = '';
      }
    });
  }

  clone() {
    const ad = new Ad();
    ad.id = this.id;
    ad.marketId = this.marketId;
    ad.marketContentFeedId = this.marketContentFeedId;
    ad.contentFeedId = this.contentFeedId;
    ad.contentFeedCategory = this.contentFeedCategory;
    ad.name = this.name;
    ad.status = this.status;
    ad.dayBudget = this.dayBudget;
    ad.startDate = this.startDate;
    ad.platform = this.platform;
    ad.advertisingGoal = this.advertisingGoal;
    ad.averagePricePerCustomer = this.averagePricePerCustomer;
    ad.productCategory = this.productCategory;
    ad.toBought = this.toBought;
    ad.toAddedCart = this.toAddedCart;
    ad.toSameType = this.toSameType;
    ad.mainCopy = this.mainCopy;
    ad.title = this.title;
    ad.description = this.description;
    ad.cta = this.cta;
    ad.hostingUrl = this.hostingUrl;
    ad.youtubeUrl = this.youtubeUrl;
    ad.shortTitle = this.shortTitle;
    ad.googleDescription = this.googleDescription;

    ad.assets = this.assets;
    ad.market = this.market.clone();
    return ad;
  }

  equals(ad) {
    return (
      ad.id === this.id
      // && ad.marketId === this.marketId
      // && ad.marketContentFeedId === this.marketContentFeedId
      && ad.contentFeedId === this.contentFeedId
      && ad.contentFeedCategory === this.contentFeedCategory
      && ad.name === this.name
      && ad.status === this.status
      && ad.dayBudget === this.dayBudget
      && ad.startDate === this.startDate
      && ad.platform === this.platform
      && ad.advertisingGoal === this.advertisingGoal
      && ad.averagePricePerCustomer === this.averagePricePerCustomer
      && ad.productCategory === this.productCategory
      && ad.toBought === this.toBought
      && ad.toAddedCart === this.toAddedCart
      && ad.toSameType === this.toSameType
      && ad.mainCopy === this.mainCopy
      && ad.title === this.title
      && ad.description === this.description
      && ad.cta === this.cta
      && ad.hostingUrl === this.hostingUrl
      && ad.youtubeUrl === this.youtubeUrl
      && ad.shortTitle === this.shortTitle
      && ad.googleDescription === this.googleDescription
    );
  }

  filterField(field, presentationFormat, productRange) {
    switch (field) {
      case 'mainCopy':
        return this.isFacebook ? this.mainCopy : '';
      case 'title':
        return (
          this.isFacebook
          && presentationFormat === PresentationFormats.Featured
            ? this.title : ''
        );
      case 'description':
        return (
          this.isFacebook
          && presentationFormat === PresentationFormats.Featured
            ? this.description : ''
        );
      case 'cta':
        return (
          this.isFacebook
          && presentationFormat === PresentationFormats.Carousel
            ? this.cta : ''
        );
      case 'hostingUrl':
        return (
          (this.isFacebook
          && productRange === ProductRanges.Selected)
          || this.isGoogle
            ? this.hostingUrl : ''
        );
      case 'youtubeUrl':
        return this.isGoogle ? this.youtubeUrl : '';
      case 'shortTitle':
        return this.isGoogle ? this.shortTitle : '';
      case 'googleDescription':
        return this.isGoogle ? this.googleDescription : '';
      default:
        return '';
    }
  }

  get valid() {
    switch (this.platform) {
      case PlatformCategories.FacebookCarousel:
        return !!(this.mainCopy && this.cta && this.hostingUrl && this.validHostingUrl);
      case PlatformCategories.FacebookFeatured:
        return !!(
          this.mainCopy
          && this.title
          && this.description
          && this.hostingUrl
          && this.validHostingUrl
        );
      case PlatformCategories.Google:
        return !!(
          this.shortTitle
          && this.googleDescription
          && this.hostingUrl
          && this.validYoutubeUrl
          && this.validHostingUrl
        );
      default:
        return false;
    }
  }

  get validWithMedia() {
    if ([PlatformCategories.Google, PlatformCategories.FacebookFeatured].includes(this.platform)
    && !this.hasMedia) {
      return false;
    }
    return this.valid;
  }

  get validWithContentFeed() {
    if (this.isGoogle
      && this.contentFeedCategory === AssetCategories.ContentFeed
      && !this.hasContentFeed
    ) {
      return false;
    }
    return this.valid;
  }

  get fullyValid() {
    return this.validWithMedia && this.validWithContentFeed;
  }

  get validForCreation() {
    return !!(
      this.marketId
      && this.name
      && this.platform
      && this.advertisingGoal
      && this.dayBudget
      && this.averagePricePerCustomer
    );
  }

  get validYoutubeUrl() {
    return !this.youtubeUrl || !!(/^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/.test(this.youtubeUrl));
  }

  get validHostingUrl() {
    return !this.hostingUrl || !!URLRegex.test(this.hostingUrl);
  }

  toNewJSON() {
    const json = {};
    json.MallId = this.marketId;
    json.MallContentId = this.marketContentFeedId;
    json.AdInventoryFile = '';
    json.InventoryId = this.contentFeedId;
    json.inventoryCategory = this.contentFeedCategory;
    json.Name = this.name;
    json.AdStatus = this.status;
    json.DayBudget = this.dayBudget;
    json.StartDate = this.startDate.toJSON();
    json.Platform = this.platform;
    // json.AdvertisingGoal = this.advertisingGoal;
    json.AvgPricePerCustomer = this.averagePricePerCustomer;
    json.ProductType = this.productCategory;
    json.ToBought = this.toBought;
    json.ToAddedCart = this.toAddedCart;
    json.ToSameType = this.toSameType;

    json.Writting = null;
    json.AdTitle = null;
    json.Description = null;
    json.MoveAppealOption = null;
    json.AdImportUrl = null;
    json.YoutubeUrl = null;
    json.ShortAdTitle = null;
    json.GoogleTitleDescrpt = null;
    json.AdTitleDescrpt = null;
    return json;
  }

  toJSON() {
    const json = {};
    json.id = this.id;
    json.mallId = this.marketId;
    json.mallContentId = this.marketContentFeedId;
    json.name = this.name;
    json.adStatus = this.status;
    json.dayBudget = this.dayBudget;
    json.startDate = this.startDate.toJSON();
    json.platform = this.platform;
    // json.advertisingGoal = this.advertisingGoal;
    json.avgPricePerCustomer = this.averagePricePerCustomer;
    json.productType = this.productCategory;
    json.toBought = this.toBought;
    json.toAddedCart = this.toAddedCart;
    json.toSameType = this.toSameType;

    json.inventoryId = this.contentFeed?.id || this.marketContentFeedId || '';
    json.inventoryCategory = this.contentFeedCategory;
    json.writting = ''; // filter('mainCopy');
    json.adTitle = ''; // filter('title');
    json.adTitleDescrpt = ''; // filter('description');
    json.moveAppealOption = ''; // filter('cta');
    json.adImportUrl = ''; // filter('hostingUrl');
    json.youtubeUrl = ''; // filter('youtubeUrl');
    json.shortAdTitle = ''; // filter('shortTitle');
    json.googleTitleDescrpt = ''; // filter('googleDescription');

    if (this.platform === PlatformCategories.FacebookCarousel) {
      json.writting = this.mainCopy;
      json.moveAppealOption = this.cta;
      json.adImportUrl = this.hostingUrl;
    } else if (this.platform === PlatformCategories.FacebookFeatured) {
      json.writting = this.mainCopy;
      json.adTitle = this.title;
      json.adTitleDescrpt = this.description;
      json.adImportUrl = this.hostingUrl;
    } else if (this.platform === PlatformCategories.Google) {
      json.shortAdTitle = this.shortTitle;
      json.googleTitleDescrpt = this.googleDescription;
      json.youtubeUrl = this.youtubeUrl;
      json.adImportUrl = this.hostingUrl;
      // json.inventoryId = this.contentFeedId || '';
    }

    // Object.keys(json).forEach((k) => {
    //   if (json[k] === '') {
    //     json[k] = null;
    //   }
    // });

    return json;
  }

  loadCopy(ad) {
    if (this.platform === PlatformCategories.FacebookCarousel) {
      this.mainCopy = ad.mainCopy;
      this.cta = ad.cta;
      this.hostingUrl = ad.hostingUrl;
    } else if (this.platform === PlatformCategories.FacebookFeatured) {
      this.mainCopy = ad.mainCopy;
      this.title = ad.title;
      this.description = ad.description;
      this.hostingUrl = ad.hostingUrl;
    } else if (this.platform === PlatformCategories.Google) {
      this.shortTitle = ad.shortTitle;
      this.googleDescription = ad.googleDescription;
      this.youtubeUrl = ad.youtubeUrl;
      this.hostingUrl = ad.hostingUrl;
      // this.contentFeed.id = ad.contentFeed.id;
    }
  }

  injectMarket(market) {
    this.market = new Market(market);
  }

  updateBudget(budget) {
    const integralBudget = parseInt(budget, 10);
    if (Number.isNaN(integralBudget) || integralBudget < 0 || integralBudget > 2147483647) {
      return;
    }
    this.dayBudget = integralBudget;
    // TODO: update starting date
  }

  get presentationFormat() {
    if (this.mainCopy && this.title && this.description) return PresentationFormats.Featured;
    if (this.mainCopy && this.cta) return PresentationFormats.Carousel;
    return '';
  }

  get productRange() {
    if (this.hasContentFeed || this.hostingUrl) return ProductRanges.Selected;
    if (this.mainCopy) return ProductRanges.Featured;
    return '';
  }

  injectAssets(assets) {
    this.assets = assets.map((a) => new Asset(a));
  }

  get contentFeed() {
    return this.assets.find((a) => a.category === AssetCategories.ContentFeed) ?? new Asset();
  }

  get media() {
    return this.assets.find((a) => a.category === AssetCategories.Media) ?? new Asset();
  }

  get hasContentFeed() {
    return !!this.contentFeed.name;
  }

  get hasMedia() {
    return !!this.media.name;
  }

  get isFacebook() {
    return [PlatformCategories.FacebookCarousel, PlatformCategories.FacebookFeatured]
      .includes(this.platform);
  }

  get isGoogle() {
    return [PlatformCategories.Google].includes(this.platform);
  }

  get earliestStartingDate() {
    return workingDaysLater(new Date(), this.market.status === '串接完成' ? 3 : 14);
  }

  get earliestStartingDateForBudgetChange() {
    return workingDaysLater(new Date(), this.market.status === '串接完成' ? 2 : 14);
  }
}
